function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1 5h22v14H1z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 5h22v1.067H1V5zm0 2.133h22V8.2H1V7.133zm22 2.134H1v1.067h22V9.267zM1 11.4h22v1.067H1V11.4zm22 2.133H1V14.6h22v-1.067zM1 15.667h22v1.066H1v-1.066zM23 17.8H1v1.067h22V17.8z",
  fill: "#E6283D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0B4266",
  d: "M1 5h9.429v7.467H1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.029 6.547c0 .302-.24.546-.537.546a.542.542 0 01-.537-.546c0-.302.24-.547.537-.547.296 0 .537.245.537.547zm2.148 0c0 .302-.24.546-.537.546a.542.542 0 01-.537-.546c0-.302.24-.547.537-.547.297 0 .537.245.537.547zm1.61.546a.542.542 0 00.536-.546A.542.542 0 006.786 6a.542.542 0 00-.536.547c0 .302.24.546.536.546zm2.685-.546c0 .302-.24.546-.537.546a.542.542 0 01-.537-.546c0-.302.24-.547.537-.547.296 0 .537.245.537.547zm-5.907 1.64a.542.542 0 00.537-.547.542.542 0 00-.537-.546.542.542 0 00-.537.546c0 .302.24.547.537.547zM6.25 7.64c0 .302-.24.547-.537.547a.542.542 0 01-.537-.547c0-.302.24-.546.537-.546.297 0 .537.244.537.546zm1.612.547a.542.542 0 00.537-.547.542.542 0 00-.537-.546.542.542 0 00-.537.546c0 .302.24.547.537.547zm1.61.547c0 .301-.24.546-.537.546a.542.542 0 01-.537-.546c0-.302.24-.547.537-.547.296 0 .537.245.537.547zm-2.684.546a.542.542 0 00.537-.546.542.542 0 00-.537-.547.542.542 0 00-.537.547c0 .301.24.546.537.546zm-1.61-.546c0 .301-.241.546-.538.546a.542.542 0 01-.537-.546c0-.302.24-.547.537-.547.297 0 .537.245.537.547zm-2.686.546a.542.542 0 00.537-.546.542.542 0 00-.537-.547.542.542 0 00-.537.547c0 .301.24.546.537.546zm1.61.547c0 .302-.24.546-.537.546a.542.542 0 01-.537-.546c0-.302.24-.547.537-.547.297 0 .537.245.537.547zm1.611.546a.542.542 0 00.537-.546.542.542 0 00-.537-.547.542.542 0 00-.537.547c0 .302.24.546.537.546zM8.4 9.827c0 .302-.24.546-.537.546a.542.542 0 01-.537-.546c0-.302.24-.547.537-.547.296 0 .537.245.537.547zm.536 1.64a.542.542 0 00.537-.547.542.542 0 00-.537-.546.542.542 0 00-.537.546c0 .302.24.547.537.547zm-1.61-.547c0 .302-.24.547-.537.547a.542.542 0 01-.537-.547c0-.302.24-.546.537-.546.297 0 .537.244.537.546zm-2.685.547a.542.542 0 00.537-.547.542.542 0 00-.537-.546.542.542 0 00-.537.546c0 .302.24.547.537.547zM3.03 10.92c0 .302-.24.547-.537.547a.542.542 0 01-.537-.547c0-.302.24-.546.537-.546.296 0 .537.244.537.546z",
  fill: "url(#american-flag_svg__paint0_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  id: "american-flag_svg__paint0_linear",
  x1: 1.955,
  y1: 6,
  x2: 1.955,
  y2: 11.467,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F0F0F0"
})));

function SvgAmericanFlag(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgAmericanFlag;